/*
* Copyright (c) 2021 RCSB PDB and contributors, licensed under MIT, See LICENSE file for more info.
* @author Joan Segura Mora <joan.segura@rcsb.org>
*/
import { RcsbFvSelectorManager } from "./RcsbFvSelectorManager";
import { AssemblyModelSate } from "./AssemblyModelSate";
import { Subject } from "rxjs";
import { DataContainer } from "../Utils/DataContainer";
export class RcsbFvStateManager {
    constructor() {
        this.assemblyModelSate = new AssemblyModelSate();
        this.selectionState = new RcsbFvSelectorManager();
        this.pfvContext = new DataContainer();
        this.subject = new Subject();
    }
    next(state) {
        this.subject.next(state);
    }
    subscribe(o) {
        return this.subject.subscribe(o);
    }
    unsubscribe() {
        this.subject.unsubscribe();
    }
}
